<script>
import { notFound } from '../analytics'
import { onMount } from 'svelte'

onMount(notFound)
</script>

<p>
  unknown route
</p>